module.exports = __webpack_public_path__ + "img/hall_slide03.e83bdf0b.jpg";